/**
 * PORTED — RO-11-04 / #44589.
 * Origin: `excellent/app/_chrome/bottom-nav-client.tsx`.
 * Changes: next/link + next/navigation → @excellent/ui/router.
 */

import type { ReactNode } from "react";
import { RouterLink as Link, usePathname } from "@excellent/ui/router";
import { cn } from "@excellent/ui";

export interface BottomNavItem {
  href: string;
  label: string;
  icon: ReactNode;
}

export function BottomNavClient({ items }: { items: BottomNavItem[] }) {
  const pathname = usePathname();
  if (items.length === 0) return null;

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border flex">
      {items.map(({ href, label, icon }) => {
        // Path-only match so query-bearing hrefs (sales?view=list) still light.
        const pathOnly = href.split("?")[0] ?? href;
        const active = pathname === pathOnly || pathname === href;
        return (
          <Link
            key={href}
            href={href}
            className={cn(
              "flex-1 flex flex-col items-center justify-center py-2.5 gap-1 transition-colors",
              active ? "text-foreground" : "text-muted-foreground hover:text-foreground",
            )}
          >
            <span className="inline-flex">{icon}</span>
            <span className="type-body leading-none">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
